/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer1_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainer2_viewer">;
    readonly " $refType": "ReplyListContainer1_viewer";
};
export type ReplyListContainer1_viewer$data = ReplyListContainer1_viewer;
export type ReplyListContainer1_viewer$key = {
    readonly " $data"?: ReplyListContainer1_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer1_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer2_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '9dcb224a6e651d34957fa4af822353f3';
export default node;
